module.exports = __webpack_public_path__ + "img/9788981337216.3c16e0de.jpg";